import React from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonPrimary } from '../../../../../utils/Button';
import InvoiceCancelModal from '../../InvoiceList/Modals/InvoiceCancelModal';
import { useInvoiceInfo } from '../InvoiceInfoProvider';

function InvoiceActionsRow({ invoiceData, noItems }) {
    const { openModal, setConfirm } = useTemplate();
    const { setHeaderLessPrint, handleReload } = useInvoiceInfo();

    const isCanceled = invoiceData?.status === 'canceled';
    const isDue = invoiceData?.status === 'due';
    const hasPayments = (invoiceData?.amountPaid || 0) > 0;

    const handleCancelInvoice = () => {
        setConfirm({
            showButton: false,
            text: <InvoiceCancelModal data={{ id: invoiceData?.id }} handleReload={handleReload} />
        });
    };
    return (
        <div className="">
            <div className="mb-4 ">
                <h2 className="text-primary text-xl font-normal">Actions</h2>
            </div>

            <div className="flex flex-wrap gap-2">
                {/* Convert quotation to invoice: any non-canceled status, amountPaid == 0, has items */}
                {invoiceData?.isQuotation ? (
                    <ButtonPrimary
                        title="Turn to Invoice"
                        onClick={() => openModal('CONVERT_QUOTATION_TO_INVOICE', invoiceData)}
                        className="normal-case "
                        disabled={isCanceled || hasPayments || noItems}
                    />
                ) : null}

                {/* Update Quotation No.: due status, authorizedBy == 0 */}
                {invoiceData?.isQuotation ? (
                    <ButtonPrimary
                        title="Update Quotation No."
                        onClick={() => openModal('update_quotation_number', invoiceData)}
                        disabled={!isDue || invoiceData?.authorizedBy > 0}
                        className="normal-case bg-[#6610f2]"
                    />
                ) : null}

                {/* Update Invoice No.: any non-canceled status */}
                {!invoiceData?.isQuotation ? (
                    <ButtonPrimary
                        title="Update Invoice No."
                        onClick={() => openModal('update_invoice_custom_number', invoiceData)}
                        disabled={isCanceled}
                        className="normal-case bg-[#6610f2]"
                    />
                ) : null}

                {/* Update Title: any non-canceled status */}
                {!invoiceData?.isQuotation ? (
                    <ButtonPrimary
                        title="Update Title"
                        onClick={() => openModal('UPDATE_INVOICE_TITLE', invoiceData)}
                        disabled={isCanceled}
                        className="normal-case bg-[#6610f2]"
                    />
                ) : null}

                {/* Update Billing Info: due status, amountPaid == 0 */}
                <ButtonPrimary
                    title="Update Billing Info"
                    onClick={() => openModal('update_invoice_billing_info')}
                    disabled={!isDue || hasPayments}
                    className="bg-warning"
                />

                {/* Update Comment: any non-canceled status */}
                <ButtonPrimary
                    title={`Update ${invoiceData?.isQuotation ? 'Quotation' : 'Invoice'} Comment`}
                    onClick={() => openModal('update_invoice_note')}
                    disabled={isCanceled}
                    className="bg-[#31d2f2]"
                />
                {invoiceData?.isQuotation ? (
                    <>
                        <ButtonPrimary
                            title="Print with Header"
                            onClick={() => {
                                setHeaderLessPrint(false);
                                setTimeout(() => {
                                    window.print();
                                }, 0);
                            }}
                            disabled={isCanceled}
                            className="bg-[#0d6efd]"
                        />
                        <ButtonPrimary
                            title="Print without Header"
                            onClick={() => {
                                setHeaderLessPrint(true);
                                setTimeout(() => {
                                    window.print();
                                }, 0);
                            }}
                            disabled={isCanceled}
                            className="bg-[#6f42c1]"
                        />
                    </>
                ) : (
                    <>
                        <ButtonPrimary
                            title="Print with Header"
                            onClick={() => {
                                setHeaderLessPrint(false);
                                setTimeout(() => {
                                    window.print();
                                }, 0);
                            }}
                            disabled={isCanceled}
                            className="bg-[#0d6efd]"
                        />
                        <ButtonPrimary
                            title="Print without Header"
                            onClick={() => {
                                setHeaderLessPrint(true);
                                setTimeout(() => {
                                    window.print();
                                }, 0);
                            }}
                            disabled={isCanceled}
                            className="bg-[#6f42c1]"
                        />
                    </>
                )}

                {/* Add Service: amountPaid == 0 */}
                <ButtonPrimary
                    title="+ Add Service"
                    onClick={() => {
                        openModal('add_new_service_item_to_invoice', invoiceData);
                    }}
                    disabled={isCanceled || hasPayments}
                />

                {/* Update Payment Info: amountPaid == 0 */}
                <ButtonPrimary
                    title="Update Payment Info"
                    onClick={() => openModal('UPDATE_INVOICE_PAYMENT_INFO')}
                    disabled={isCanceled || hasPayments}
                    className="bg-[#198754]"
                />

                {/* Cancel: due status, amountPaid == 0 */}
                <ButtonPrimary
                    title="Cancel"
                    onClick={handleCancelInvoice}
                    disabled={!isDue || hasPayments}
                    className="bg-error"
                />
            </div>
        </div>
    );
}

export default InvoiceActionsRow;
